import { buildRoute } from '@direct-frontend/modules-router';

export const addonsRoute = buildRoute('/addons');

export type AddonsEditParams = { addonId: string };
export const ADDON_ID_NEW = 'new';
export const addonsEditRoute = buildRoute<AddonsEditParams>('/addon/:addonId');
